import React from 'react';
import PropTypes from 'prop-types';
import { TextStyled } from '@nike/nike-design-system-components';
import styles from './styles.styl';

export const ProgressBar = ({ currentStep, stepsNumber }) => {
  return (
    <>
      <progress
        id="progress"
        max={stepsNumber}
        value={currentStep}
        className={styles.styledProgressBar}
        data-testid="styled-progress-bar"
      />
      <label
        htmlFor="progress"
        className={styles.progressBarLabel}
        data-testid="progress-bar-label"
      >
        <TextStyled appearance="body1Strong">
          {`(${currentStep}/${stepsNumber})`}
        </TextStyled>
      </label>
    </>
  );
};

ProgressBar.propTypes = {
  currentStep: PropTypes.number.isRequired,
  stepsNumber: PropTypes.number.isRequired,
};
